import customAxiosInterceptor from "../customAxiosInterceptor";
import { ErrorResponse } from "../index";
import { CatalogDetail, CatalogResponse } from "./CatalogType";

// Fetch catalog
// GET https://api.infocomp.ba/api/catalog/latest
export const fetchCatalogThunk = async (
  _: void,
  thunkAPI: any
): Promise<CatalogDetail | ReturnType<typeof thunkAPI.rejectWithValue>> => {
  try {
    const response = await customAxiosInterceptor.get<CatalogResponse>(
      "/catalog/latest"
    );

    return response.data.data;
  } catch (error: any) {
    const errorResponse = error.response.data as ErrorResponse;
    return thunkAPI.rejectWithValue(errorResponse.msg);
  }
};
